<template>
    <div id="bloco-tabela-territorio-gestao">
        <div class="tabela-certificacoes-inseridas-listagem">
            <el-tooltip
                effect="dark"
                :content="$tc('certification.messages.reload_table')"
                placement="top"
                v-if="btnRecarregar"
            >
                <el-button
                    type="info"
                    icon="el-icon-refresh"
                    size="mini"
                    @click.native="atualizarTabela"
                />
            </el-tooltip>
        </div>
        <el-table
            :data="tabelaData"
            v-loading="carregando"
            style="width: 100%"
            @sort-change="sortChangeRequest"
            :default-sort="{ prop: 'dataCadastro', order: 'ascending' }"
            stripe
        >
            <el-table-column type="expand" width="45" align="center">
                <template slot-scope="scope">
                    <el-descriptions
                        class="descricao-item-tabela areas"
                        :size="'mini'"
                        :column="8"
                    >
                        <el-descriptions-item
                            class="area-total"
                            :label="
                                $tc(
                                    'certification.messages.table.territory_total_area'
                                )
                            "
                            :span="2"
                        >
                            <p class="area-ha">
                                {{
                                    formatarArea(
                                        scope.row.geometrias[0].areaHaTerritorio
                                    )
                                }}
                                ha
                            </p>
                        </el-descriptions-item>
                        <el-descriptions-item
                            class="area-total"
                            :label="
                                $tc(
                                    'certification.messages.table.territory_planted_area'
                                )
                            "
                            :span="2"
                        >
                            <p class="area-ha">
                                {{
                                    scope.row.geometrias[0].areaPlantadaHa
                                        ? formatarArea(
                                              scope.row.geometrias[0]
                                                  .areaPlantadaHa
                                          ) + ' ha'
                                        : '-'
                                }}
                            </p>
                        </el-descriptions-item>
                        <el-descriptions-item
                            :label="
                                scope.row.possuiCertificacaoRelacionada
                                    ? $tc(
                                          'certification.messages.table.certification_2bsvs_cutout'
                                      )
                                    : '2BSvs'
                            "
                        >
                            <p>
                                {{
                                    scope.row.geometrias[0].areaElegivel2BSvs
                                        ? formatarArea(
                                              scope.row.geometrias[0]
                                                  .areaElegivel2BSvs
                                          ) + ' ha'
                                        : '-'
                                }}
                            </p>
                        </el-descriptions-item>
                        <el-descriptions-item label="PROTERRA">
                            <p>
                                {{
                                    scope.row.geometrias[0].areaElegivelProterra
                                        ? formatarArea(
                                              scope.row.geometrias[0]
                                                  .areaElegivelProterra
                                          ) + ' ha'
                                        : '-'
                                }}
                            </p>
                        </el-descriptions-item>
                        <el-descriptions-item label="RTRS">
                            <p>
                                {{
                                    scope.row.geometrias[0].areaElegivelRTRS
                                        ? formatarArea(
                                              scope.row.geometrias[0]
                                                  .areaElegivelRTRS
                                          ) + ' ha'
                                        : '-'
                                }}
                            </p>
                        </el-descriptions-item>
                        <el-descriptions-item label="EPA">
                            <p>
                                {{
                                    scope.row.geometrias[0].areaElegivelEPA
                                        ? formatarArea(
                                              scope.row.geometrias[0]
                                                  .areaElegivelEPA
                                          ) + ' ha'
                                        : '-'
                                }}
                            </p>
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                    >
                        <el-descriptions-item
                            :label="`${$tc(
                                'certification.messages.table.people'
                            )}:`"
                            v-if="
                                scope.row.representantes &&
                                scope.row.representantes.length > 1
                            "
                        >
                            <div
                                class="representantes"
                                v-for="representante in scope.row
                                    .representantes"
                                :key="representante.id"
                            >
                                <p>{{ representante.nomeRepresentante }}</p>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                        v-if="
                            scope.row.representantes &&
                            scope.row.representantes.length === 1
                        "
                    >
                        <el-descriptions-item
                            class="has-colon-not"
                            :label="
                                $tc(
                                    'certification.messages.table.no_additional_people'
                                )
                            "
                        ></el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                        v-if="
                            scope.row.representantes &&
                            scope.row.representantes.length === 0
                        "
                    >
                        <el-descriptions-item
                            class="has-colon-not"
                            :label="
                                $tc('certification.messages.table.no_people')
                            "
                        ></el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                    >
                        <el-descriptions-item
                            :label="$tc('certification.messages.table.car')"
                            v-if="scope.row.cars && scope.row.cars.length > 1"
                        >
                            <div class="car-list-row">
                                <div
                                    class="cars"
                                    v-for="car in scope.row.cars"
                                    :key="car?.codigo"
                                >
                                    <p>{{ car?.codigo }}</p>
                                </div>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                        v-if="scope.row.cars && scope.row.cars.length === 1"
                    >
                        <el-descriptions-item
                            class="has-colon-not"
                            :label="
                                $tc(
                                    'certification.messages.table.no_additional_cars'
                                )
                            "
                        ></el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                        v-if="scope.row.cars && scope.row.cars.length === 0"
                    >
                        <el-descriptions-item
                            class="has-colon-not"
                            :label="$tc('certification.messages.table.no_cars')"
                        ></el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-table-column>
            <el-table-column
                prop="nomeTerritorio"
                :label="$tc('certification.words.territory')"
                width="auto"
                min-width="175"
                max-width="350"
                serializable="true"
            >
                <template slot-scope="scope">
                    <div class="territorio" v-if="scope.row?.nomeTerritorio">
                        <p class="territorio-hiden-row">
                            {{ scope.row?.nomeTerritorio.toUpperCase() }}
                        </p>
                    </div>
                    <div class="territorio" v-else>
                        <p>-</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="cars"
                label="CAR"
                width="auto"
                max-width="200"
                flex="1"
            >
                <template slot-scope="scope">
                    <div
                        class="car"
                        v-if="scope.row.cars && scope.row.cars.length > 0"
                    >
                        <p class="car-hiden-row">
                            {{ formatarCar(scope.row.cars[0]?.codigo) }}
                        </p>
                        <el-tag
                            class="ml-2"
                            v-if="scope.row.cars.length > 1"
                            size="mini"
                        >
                            + {{ scope.row.cars.length - 1 }}
                        </el-tag>
                    </div>
                    <div class="car" v-else>
                        <p>-</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="dataUltimaAnalise"
                :label="$tc('certification.words.last_analysis')"
                width="auto"
                max-width="200"
                flex="1"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.dataUltimaAnalise">
                        <p>{{ formatarData(scope.row.dataUltimaAnalise) }}</p>
                    </div>
                    <div v-else>
                        <p>-</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                class="elegivel"
                prop="certificacaoTerritorioResultado"
                label="2BSvs"
            >
                <template slot-scope="scope">
                    <div class="flex-container">
                        <div
                            v-if="scope.row.certificacaoTerritorioResultado[0]"
                        >
                            <div
                                class="certificacaoTipo"
                                v-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo === 'NAO_ANALISADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-remove-outline disabled-font-color"
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo === 'EM_ANALISE'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon class="el-icon-loading"></el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo === 'INELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo ===
                                    'PARCIALMENTE_ELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-check danger-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo === 'NAO_SE_APLICA'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo === 'EM_ANALISE'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo === 'PROCESSADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-checked sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[0]
                                        .resultadoCodigo ===
                                    'ERRO_PROCESSAMENTO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-delete error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div class="certificacaoTipo" v-else>
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[0]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-check"
                                        :class="
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoCodigo ===
                                                'ELEGIVEL' ||
                                            scope.row
                                                .certificacaoTerritorioResultado[0]
                                                .resultadoParcial === 'ELEGIVEL'
                                                ? 'success-font-color'
                                                : 'danger-font-color'
                                        "
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                        <div v-else>
                            <div class="certificacaoTipo">
                                <el-icon class="el-icon-loading"></el-icon>
                            </div>
                        </div>
                        <div>
                            <el-tooltip
                                effect="dark"
                                :content="
                                    scope.row.certificacoes[0].status
                                        ? 'Certificado'
                                        : 'Não certificado'
                                "
                                placement="top"
                            >
                                <i
                                    class="mdi mdi-medal"
                                    :class="
                                        scope.row.certificacoes[0].status
                                            ? 'success-font-color'
                                            : 'disabled-font-color'
                                    "
                                ></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                class="elegivel"
                prop="certificacaoTerritorioResultado"
                label="Proterra"
            >
                <template slot-scope="scope">
                    <div class="flex-container">
                        <div
                            v-if="scope.row.certificacaoTerritorioResultado[1]"
                        >
                            <div
                                class="certificacaoTipo"
                                v-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo === 'EM_ANALISE'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon class="el-icon-loading"></el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo === 'NAO_ANALISADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-remove-outline disabled-font-color"
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo === 'INELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo ===
                                    'PARCIALMENTE_ELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close danger-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo === 'NAO_SE_APLICA'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo === 'EM_ANALISE'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo === 'PROCESSADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-checked sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[1]
                                        .resultadoCodigo ===
                                    'ERRO_PROCESSAMENTO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-delete error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div class="certificacaoTipo" v-else>
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-check"
                                        :class="
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoCodigo ===
                                                'ELEGIVEL' ||
                                            scope.row
                                                .certificacaoTerritorioResultado[1]
                                                .resultadoParcial === 'ELEGIVEL'
                                                ? 'success-font-color'
                                                : 'danger-font-color'
                                        "
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                        <div v-else>
                            <div class="certificacaoTipo">
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[1]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon class="el-icon-loading"></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                        <div>
                            <el-tooltip
                                effect="dark"
                                :content="
                                    scope.row.certificacoes[1].status
                                        ? 'Certificado'
                                        : 'Não certificado'
                                "
                                placement="top"
                            >
                                <i
                                    class="mdi mdi-medal"
                                    :class="
                                        scope.row.certificacoes[1].status
                                            ? 'success-font-color'
                                            : 'disabled-font-color'
                                    "
                                ></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                class="elegivel"
                prop="certificacaoTerritorioResultado"
                label="RTRS"
            >
                <template slot-scope="scope">
                    <div class="flex-container">
                        <div
                            v-if="scope.row.certificacaoTerritorioResultado[2]"
                        >
                            <div
                                class="certificacaoTipo"
                                v-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo === 'NAO_ANALISADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-remove-outline disabled-font-color"
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo === 'INELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo ===
                                    'PARCIALMENTE_ELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close danger-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo === 'NAO_SE_APLICA'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo === 'EM_ANALISE'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo === 'PROCESSADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-checked sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[2]
                                        .resultadoCodigo ===
                                    'ERRO_PROCESSAMENTO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-delete error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div class="certificacaoTipo" v-else>
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[2]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-check"
                                        :class="
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoCodigo ===
                                                'ELEGIVEL' ||
                                            scope.row
                                                .certificacaoTerritorioResultado[2]
                                                .resultadoParcial === 'ELEGIVEL'
                                                ? 'success-font-color'
                                                : 'danger-font-color'
                                        "
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                        <div v-else>
                            <div class="certificacaoTipo">
                                <el-icon class="el-icon-loading"></el-icon>
                            </div>
                        </div>
                        <div>
                            <el-tooltip
                                effect="dark"
                                :content="
                                    scope.row.certificacoes[2].status
                                        ? 'Certificado'
                                        : 'Não certificado'
                                "
                                placement="top"
                            >
                                <i
                                    class="mdi mdi-medal"
                                    :class="
                                        scope.row.certificacoes[2].status
                                            ? 'success-font-color'
                                            : 'disabled-font-color'
                                    "
                                ></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                class="elegivel"
                prop="certificacaoTerritorioResultado"
                label="EPA"
                width="auto"
                max-width="125"
                flex="1"
            >
                <template slot-scope="scope">
                    <div class="flex-container">
                        <div
                            v-if="scope.row.certificacaoTerritorioResultado[3]"
                        >
                            <div
                                class="certificacaoTipo"
                                v-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo === 'NAO_ANALISADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-remove-outline disabled-font-color"
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo === 'INELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo ===
                                    'PARCIALMENTE_ELEGIVEL'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-close danger-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo === 'NAO_SE_APLICA'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-close error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo === 'EM_ANALISE'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo === 'PROCESSADO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-checked sucess-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div
                                class="certificacaoTipo"
                                v-else-if="
                                    scope.row.certificacaoTerritorioResultado[3]
                                        .resultadoCodigo ===
                                    'ERRO_PROCESSAMENTO'
                                "
                            >
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-document-delete error-font-color"
                                    >
                                        {{
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoNome
                                        }}
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div class="certificacaoTipo" v-else>
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        scope.row
                                            .certificacaoTerritorioResultado[3]
                                            .resultadoNome
                                    "
                                    placement="top"
                                >
                                    <el-icon
                                        class="el-icon-circle-check"
                                        :class="
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoCodigo ===
                                                'ELEGIVEL' ||
                                            scope.row
                                                .certificacaoTerritorioResultado[3]
                                                .resultadoParcial === 'ELEGIVEL'
                                                ? 'success-font-color'
                                                : 'danger-font-color'
                                        "
                                    ></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                        <div v-else>
                            <div class="certificacaoTipo">
                                <el-icon class="el-icon-loading"></el-icon>
                            </div>
                        </div>
                        <div>
                            <el-tooltip
                                effect="dark"
                                :content="
                                    scope.row.certificacoes[3].status
                                        ? 'Certificado'
                                        : 'Não certificado'
                                "
                                placement="top"
                            >
                                <i
                                    class="mdi mdi-medal"
                                    :class="
                                        scope.row.certificacoes[3].status
                                            ? 'success-font-color'
                                            : 'disabled-font-color'
                                    "
                                ></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="cars"
                :label="$tc('certification.words.state_country')"
                width="auto"
                max-width="100"
            >
                <template slot-scope="scope">
                    <div class="ufPais">
                        <p>{{ scope.row.cars[0]?.codigo.substr(0, 2) }}</p>
                        <span
                            >/{{
                                getPais(scope.row.cars[0]?.codigo.substr(0, 2))
                            }}</span
                        >
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :label="$tc('certification.words.actions')"
                align="center"
            >
                <template slot-scope="scope">
                    <el-dropdown class="action-button" trigger="click">
                        <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-vertical"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                icon="el-icon-view"
                                @click.native="
                                    detalhamentoAnalise(scope.row.id)
                                "
                            >
                                {{ $t('certification.messages.detail_analysis') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-delete"
                                @click.native="removerCertificacao(scope.row)"
                            >
                                {{ $t('certification.words.remove') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-refresh-right"
                                @click.native="abreModalGerarAnalise(scope.row)"
                            >
                                {{ $t('certification.messages.generate_new_analysis') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="tabela-gestao-contrato-originacao__paginacao">
            <div>
                <span class="pagina"
                    >{{ paginacao.total }}
                    {{
                        $tc('certification.words.territory', paginacao.total)
                    }}</span
                >
            </div>
            <el-pagination
                background
                :page-size="paginacao.itensPorPagina"
                :pager-count="5"
                :current-page.sync="paginacao.pagina + 1"
                layout="prev, pager, next"
                :total="paginacao.total"
                @current-change="mudarPagina"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import formatters from '@/utils/formatters';
import CertificacaoService from '@/services/CertificacaoService';

export default {
    name: 'TabelaGestaoCertificacao',
    emits: [
        'handleModalGerarAnalise'
    ],
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: false
        },
        carregando: {
            type: Boolean,
            required: false
        },
        paginacao: {
            type: Object,
            required: true
        },
        btnRecarregar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            currentPage: 1
        };
    },
    methods: {
        mudarPagina(novaPagina) {
            document.querySelector('#base-header').scrollIntoView();
            this.$emit('mudarPagina', novaPagina - 1);
        },
        formatarCar(car) {
            return formatters.reduzirCar(car);
        },
        formatarArea(area) {
            return formatters.maxFormatNumber(area, 2);
        },
        formatarData(data) {
            const date = new Date(data);
            return `${String(date.getDate()).padStart(2, '0')}/${String(
                date.getMonth() + 1
            ).padStart(2, '0')}/${date.getFullYear()}`;
        },
        sortChangeRequest(column) {
            return this.$emit('ordenarTabela', column);
        },
        detalhamentoAnalise(idCertificacao) {
            if (!idCertificacao) return;
            this.$router.push({
                name: 'VisualizarAnalise',
                params: { idCertificacao }
            });
        },
        getPais(uf) {
            const estadosDoBr = [
                { uf: 'AC', pais: 'BR' },
                { uf: 'AL', pais: 'BR' },
                { uf: 'AP', pais: 'BR' },
                { uf: 'AM', pais: 'BR' },
                { uf: 'BA', pais: 'BR' },
                { uf: 'CE', pais: 'BR' },
                { uf: 'DF', pais: 'BR' },
                { uf: 'ES', pais: 'BR' },
                { uf: 'GO', pais: 'BR' },
                { uf: 'MA', pais: 'BR' },
                { uf: 'MT', pais: 'BR' },
                { uf: 'MS', pais: 'BR' },
                { uf: 'MG', pais: 'BR' },
                { uf: 'PA', pais: 'BR' },
                { uf: 'PB', pais: 'BR' },
                { uf: 'PR', pais: 'BR' },
                { uf: 'PE', pais: 'BR' },
                { uf: 'PI', pais: 'BR' },
                { uf: 'RJ', pais: 'BR' },
                { uf: 'RN', pais: 'BR' },
                { uf: 'RS', pais: 'BR' },
                { uf: 'RO', pais: 'BR' },
                { uf: 'RR', pais: 'BR' },
                { uf: 'SC', pais: 'BR' },
                { uf: 'SP', pais: 'BR' },
                { uf: 'SE', pais: 'BR' },
                { uf: 'TO', pais: 'BR' }
            ];
            return estadosDoBr.find(estado => estado.uf === uf)?.pais;
        },
        async removerCertificacao(row) {
            try {
                const result = await this.$messageBox.confirm(
                    this.$t('certification.messages.confirm_delete_territory_certification', {
                        territory: row.nomeTerritorio
                    }),
                    this.$tc('certification.words.warning'),
                    {
                        confirmButtonText: this.$tc('certification.words.yes'),
                        cancelButtonText: this.$tc('certification.words.cancel'),
                        type: 'warning'
                    }
                );
                if (result) {
                    const resultado =
                        await CertificacaoService.removerCertificacao(row.id);
                    this.$notify.success({
                        message: resultado.data
                    });
                    this.$emit('atualizarTabela');
                }
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        },
        abreModalGerarAnalise(row) {
            this.$emit('handleModalGerarAnalise', row);
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-tabela-territorio-gestao {
    h1,
    .el-checkbox {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .el-table td {
        padding: 12px 0px;
        vertical-align: top;
        border-top: 1px solid #e9ecef;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    span.el-descriptions-item__label.has-colon {
        font-weight: bold;
    }

    .success-font-color {
        color: var(--success);
    }

    .danger-font-color {
        color: var(--danger);
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .tabela-certificacoes-inseridas-listagem {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
    }

    .el-icon-download {
        font-size: 16px;
        color: var(--primary);
        margin-left: 10px;
        cursor: pointer;
    }
}

i {
    color: var(--primary);

    &.parcialmente-elegivel {
        color: var(--warning);
    }
}

.error-font-color {
    color: red;
}

.disabled-font-color {
    color: #c0c0c0;
}

.flex-container {
    display: flex;
    align-items: center;
}
</style>
